import { Voicemail } from '../../voicemails/Voicemail.model';
import { relationshipOneToManyGetChildren } from './relationshipsOneToMany.selector';

export const getLineVoicemailsSelector = (lineId: string) =>
  relationshipOneToManyGetChildren<Voicemail>('lineVoicemails', lineId, 'voicemails');
